import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/new-axelerate-logo.svg'


const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "text-white bg-primary py-2" }
const _hoisted_3 = { class: "container flex flex-row justify-between items-center" }
const _hoisted_4 = { class: "flex flex-row justify-end" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-6"
}, null, -1)
const _hoisted_6 = { class: "flex flex-row justify-center items-center space-x-6" }
const _hoisted_7 = { class: "flex flex-row" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Your ")
const _hoisted_9 = { class: "font-semibold text-primary" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" subscription has exceeded the plan limits. Please upgrade your account. ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" > ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuDropDown = _resolveComponent("MenuDropDown")!
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_MenuDropDown, { onLogOut: _ctx.logOut }, null, 8, ["onLogOut"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_NavBar),
    _createVNode(_component_base_modal, { visible: _ctx.showModal }, {
      "alert-text": _withCtx(() => [
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.profile.active_plan.plan_name), 1),
        _hoisted_10
      ]),
      actions: _withCtx(() => [
        _createElementVNode("button", {
          class: "btn-outline-sm flex flex-row items-center disabled:opacity-50 justify-between px-4 py-2 text-primary truncate sm:text-base border-2 rounded-full transition duration-150 ease-in",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(false)), ["prevent"]))
        }, " Decline "),
        _createElementVNode("button", {
          class: "btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate sm:text-base bg-primary rounded-full transition duration-150 ease-in",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(true)), ["prevent"]))
        }, " Upgrade ")
      ]),
      default: _withCtx(() => [
        _hoisted_11
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}